import _ = require("underscore");
import Portal = require("portal-gis");
import baseTemplate = require("./infoviewer-template");

function render(feature: Rhythm.GIS.FeatureQueryResultFeature) {
    let html = baseTemplate(feature);
    /**
     * TODO: ideally this would be a command registered with the popup control but there is no popup control
     * so using a template to get the button on the control that will trigger a 'feature-zoom' event
     */
    html += `<button class="infoviewer-command" data-event="feature-zoom">VIEW DETAILS</button>`;
    return html;
}


export = render;